export const silentlyReplaceSearchParams = (params: string | URLSearchParams) => {
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${params === "" ? "" : `?${params}`}`;
    window.history.replaceState({ ...window.history.state, newUrl }, "", newUrl);
};